import { useEffect, useMemo } from 'react';

import { usePage } from '@/hooks/usePage';
const PageWrap = ({ children }: any) => {
    const { onLoad } = usePage();

    const render = useMemo(() => {
        return <>{children}</>;
    }, [children]);

    useEffect(() => {
        onLoad(render);
    }, [onLoad, render]);

    return render;
};

export default PageWrap;
